import { Button, Typography } from '@mui/material';
import { getTrans } from 'modules/i18n';
import { Iconify } from 'modules/minimal-ui-theme';

export const DeleteButton = ({
  onDeleteItem
}: {
  onDeleteItem: () => void;
}) => (
  <Button
    data-testid="delete-item-button"
    variant="outlined"
    startIcon={<Iconify icon="solar:trash-bin-trash-bold" width={18} />}
    onClick={onDeleteItem}
    sx={{
      borderColor: 'error.main',
      color: 'error.main',
      height: '30px'
    }}
  >
    <Typography variant="body2" fontWeight="bold">
      {getTrans('general.delete')}
    </Typography>
  </Button>
);
